import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

const routeLabels: Record<string, string> = {
  '': '首页',
  category: '分类',
  article: '文章详情',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs: { label: string; to: string }[] = [
    { label: '首页', to: '/' },
  ];

  let currentPath = '';
  for (const segment of pathSegments) {
    currentPath += `/${segment}`;
    let label = routeLabels[segment] || '';

    if (segment === 'category') continue;

    if (pathSegments[0] === 'category' && pathSegments.length > 1 && segment === pathSegments[1]) {
      const cat = categories.find((c) => c.slug === segment);
      label = cat ? cat.name : segment;
    }

    if (pathSegments[0] === 'article') {
      label = '文章详情';
    }

    if (pathSegments[0] === 'about') {
      label = '关于我们';
    }

    if (label) {
      breadcrumbs.push({ label, to: currentPath });
    }
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li key={crumb.to} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1">
                  <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              )}
              {isLast ? (
                <span className="text-foreground-700 font-medium">{crumb.label}</span>
              ) : (
                <Link
                  to={crumb.to}
                  className="text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {crumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}